/**
 * This code was generated by Builder.io.
 */
import React, {useState} from "react";
import styled from "styled-components";
import Header from "./Header";
import CourseTabs from "./CourseTabs";
import SubNavigation from "./SubNavigation";
import CourseCard from "./CourseCard";
import CareerCounselling from "./CareerCounselling";
import Footer from "../CommonComponents/Footer/Footer";

const CoursesListing = () => {

  const [type,setType] = useState("frontend");
  const courses = {
    'frontend' : [
      {
        imageSrc : "https://cdn.builder.io/api/v1/image/assets/TEMP/2fd32f4ac4b13c496e37b7a961c891720de8bd47ba57740f318a3de28bb64351?apiKey=a6dad463439244ae86e3212633b4369a&&apiKey=a6dad463439244ae86e3212633b4369a",
        image:
          "https://cdn.builder.io/api/v1/image/assets/TEMP/c50619eaecb6ea80d38d5e33f0271d68ba1f06c77031b21b7d08664c64c3c455?apiKey=a6dad463439244ae86e3212633b4369a&&apiKey=a6dad463439244ae86e3212633b4369a",
        title: "Mastering ReactJS for Modern Web Development",
        description: "ReactJS, developed by Facebook, is a popular JavaScript library for building user interfaces, especially single-page applications. It allows developers to create reusable UI components with their own state. Using a virtual DOM, React ensures high performance and is widely favored for front-end development due to its flexibility and integration capabilities.",
        startDate: "August 15",
        learners: 12345,
        averageRating: 5.5,
        reviewsCount: "5k",
        name: "react"
      },
      {
        imageSrc : "https://cdn.builder.io/api/v1/image/assets/TEMP/2fd32f4ac4b13c496e37b7a961c891720de8bd47ba57740f318a3de28bb64351?apiKey=a6dad463439244ae86e3212633b4369a&&apiKey=a6dad463439244ae86e3212633b4369a",
        image:
          "https://cdn.builder.io/api/v1/image/assets/TEMP/510622f50ff15446a7314b66bf2dd6ff555efd04a575154550b38d317f46f3f4?apiKey=a6dad463439244ae86e3212633b4369a&&apiKey=a6dad463439244ae86e3212633b4369a",
        title: "Mastering JavaScript for Interactive Web Development",
        description: "Welcome to the Comprehensive JavaScript Mastery course! Designed for beginners to advanced learners, this course takes you from the basics to expert-level JavaScript programming. Whether you're new to coding or want to deepen your knowledge, you'll gain the skills needed to master one of the world's most popular programming languages.",
        startDate: "August 15",
        learners: 12345,
        averageRating: 5.5,
        reviewsCount: "5k",
        name: "javascript"
      },
      {
        imageSrc : "https://cdn.builder.io/api/v1/image/assets/TEMP/2fd32f4ac4b13c496e37b7a961c891720de8bd47ba57740f318a3de28bb64351?apiKey=a6dad463439244ae86e3212633b4369a&&apiKey=a6dad463439244ae86e3212633b4369a",
        image:
          "https://cdn.builder.io/api/v1/image/assets/TEMP/9c20afe8f03bf41781ded8405d2f6918ebadaeb65a5b0936c9064a44904047e7?apiKey=a6dad463439244ae86e3212633b4369a&&apiKey=a6dad463439244ae86e3212633b4369a",
        title: "Mastering jQuery for Interactive Web Development",
        description: "This course will teach you how to use jQuery, a fast, small, and feature-rich JavaScript library. You will learn how to simplify the client-side scripting of HTML, enhance your web pages with dynamic features, and create interactive, user-friendly interfaces.",
        startDate: "August 15",
        learners: 12345,
        averageRating: 5.5,
        reviewsCount: "5k",
        name: "jquery"
      }
    ],
    'backend' : [
      {
        imageSrc : "https://cdn.builder.io/api/v1/image/assets/TEMP/2fd32f4ac4b13c496e37b7a961c891720de8bd47ba57740f318a3de28bb64351?apiKey=a6dad463439244ae86e3212633b4369a&&apiKey=a6dad463439244ae86e3212633b4369a",
        image:
          "https://cdn.builder.io/api/v1/image/assets/TEMP/c50619eaecb6ea80d38d5e33f0271d68ba1f06c77031b21b7d08664c64c3c455?apiKey=a6dad463439244ae86e3212633b4369a&&apiKey=a6dad463439244ae86e3212633b4369a",
        title: "Mastering Java Programming: From Basics to Advanced Concepts",
        description: `Unlock Java's full potential with this comprehensive course for beginners and experienced developers. Start with Java fundamentals, then advance to object-oriented programming, multithreading, and network programming. Gain hands-on experience through practical exercises and build a Java project. Learn best practices and design patterns to prepare for real-world challenges.`,
        startDate: "August 15",
        learners: 12345,
        averageRating: 5.5,
        reviewsCount: "5k",
        name: "java"
      },
      {
        imageSrc : "https://cdn.builder.io/api/v1/image/assets/TEMP/2fd32f4ac4b13c496e37b7a961c891720de8bd47ba57740f318a3de28bb64351?apiKey=a6dad463439244ae86e3212633b4369a&&apiKey=a6dad463439244ae86e3212633b4369a",
        image:
          "https://cdn.builder.io/api/v1/image/assets/TEMP/510622f50ff15446a7314b66bf2dd6ff555efd04a575154550b38d317f46f3f4?apiKey=a6dad463439244ae86e3212633b4369a&&apiKey=a6dad463439244ae86e3212633b4369a",
        title: "Mastering Node.js: From Basics to Advanced",
        description: "This comprehensive Node.js course takes you from foundational concepts to advanced techniques in building server-side applications. You will explore Node.js core modules, asynchronous programming, web development with Express, real-time communication with WebSocket, and best practices for optimizing and deploying Node.js applications.",
        startDate: "August 15",
        learners: 12345,
        averageRating: 5.5,
        reviewsCount: "5k",
        name: "nodejs"
      },
      {
        imageSrc : "https://cdn.builder.io/api/v1/image/assets/TEMP/2fd32f4ac4b13c496e37b7a961c891720de8bd47ba57740f318a3de28bb64351?apiKey=a6dad463439244ae86e3212633b4369a&&apiKey=a6dad463439244ae86e3212633b4369a",
        image:
          "https://cdn.builder.io/api/v1/image/assets/TEMP/9c20afe8f03bf41781ded8405d2f6918ebadaeb65a5b0936c9064a44904047e7?apiKey=a6dad463439244ae86e3212633b4369a&&apiKey=a6dad463439244ae86e3212633b4369a",
        title: "Mastering Spring Boot: From Fundamentals to Advanced",
        description: "This comprehensive course covers the fundamentals of Spring Boot, a powerful framework for building Java enterprise applications. Learn to develop scalable, secure, and efficient web apps by mastering core concepts, advanced features, and best practices. Gain practical experience through hands-on exercises and real-world projects to effectively leverage Spring Boot.",
        startDate: "August 15",
        learners: 12345,
        averageRating: 5.5,
        reviewsCount: "5k",
        name: "springboot"
      }
    ],
    'database' : [
      {
        imageSrc : "https://cdn.builder.io/api/v1/image/assets/TEMP/2fd32f4ac4b13c496e37b7a961c891720de8bd47ba57740f318a3de28bb64351?apiKey=a6dad463439244ae86e3212633b4369a&&apiKey=a6dad463439244ae86e3212633b4369a",
        image:
          "https://cdn.builder.io/api/v1/image/assets/TEMP/c50619eaecb6ea80d38d5e33f0271d68ba1f06c77031b21b7d08664c64c3c455?apiKey=a6dad463439244ae86e3212633b4369a&&apiKey=a6dad463439244ae86e3212633b4369a",
        title: "Mastering MySQL: From Fundamentals to Advanced Database Management",
        description: `This comprehensive course takes you from MySQL basics to advanced database management techniques. Learn to design, implement, and manage databases efficiently, ensuring high performance and scalability. The course covers SQL querying, database design, optimization strategies, and real-world use cases, equipping you with the skills to manage complex databases in various environments.`,
        startDate: "August 15",
        learners: 12345,
        averageRating: 5.5,
        reviewsCount: "5k",
        name: "mysql"
      },
      {
        imageSrc : "https://cdn.builder.io/api/v1/image/assets/TEMP/2fd32f4ac4b13c496e37b7a961c891720de8bd47ba57740f318a3de28bb64351?apiKey=a6dad463439244ae86e3212633b4369a&&apiKey=a6dad463439244ae86e3212633b4369a",
        image:
          "https://cdn.builder.io/api/v1/image/assets/TEMP/510622f50ff15446a7314b66bf2dd6ff555efd04a575154550b38d317f46f3f4?apiKey=a6dad463439244ae86e3212633b4369a&&apiKey=a6dad463439244ae86e3212633b4369a",
        title: "Mastering MongoDB: From Fundamentals to Advanced Features",
        description: "This course covers MongoDB from basics to advanced features, including CRUD operations, schema design, query optimization, aggregation, replication, sharding, and security. You'll also learn backup, recovery, performance tuning, geospatial queries, full-text search, and transactions. By the end, you'll be ready to manage MongoDB databases in real-world applications.",
        startDate: "August 15",
        learners: 12345,
        averageRating: 5.5,
        reviewsCount: "5k",
        name: "mongodb"
      }
    ],
    'ui_ux' : [
      {
        imageSrc : "https://cdn.builder.io/api/v1/image/assets/TEMP/2fd32f4ac4b13c496e37b7a961c891720de8bd47ba57740f318a3de28bb64351?apiKey=a6dad463439244ae86e3212633b4369a&&apiKey=a6dad463439244ae86e3212633b4369a",
        image:
          "https://cdn.builder.io/api/v1/image/assets/TEMP/c50619eaecb6ea80d38d5e33f0271d68ba1f06c77031b21b7d08664c64c3c455?apiKey=a6dad463439244ae86e3212633b4369a&&apiKey=a6dad463439244ae86e3212633b4369a",
        title: "Design Mastery with Figma: From Basics to Advanced Techniques",
        description: "This course is for aspiring designers and professionals aiming to master Figma, a powerful design tool. You'll start with Figma's basics, progressing to advanced topics like prototyping, design systems, and collaboration. By the end, you'll be proficient in creating sophisticated designs and working effectively with teams using Figma.",
        startDate: "August 15",
        learners: 12345,
        averageRating: 5.5,
        reviewsCount: "5k",
        name: "figma"
      },
      {
        imageSrc : "https://cdn.builder.io/api/v1/image/assets/TEMP/2fd32f4ac4b13c496e37b7a961c891720de8bd47ba57740f318a3de28bb64351?apiKey=a6dad463439244ae86e3212633b4369a&&apiKey=a6dad463439244ae86e3212633b4369a",
        image:
          "https://cdn.builder.io/api/v1/image/assets/TEMP/510622f50ff15446a7314b66bf2dd6ff555efd04a575154550b38d317f46f3f4?apiKey=a6dad463439244ae86e3212633b4369a&&apiKey=a6dad463439244ae86e3212633b4369a",
        title: "Mastering HTML: From Basics to Advanced",
        description: "This course provides a comprehensive introduction to HTML, the cornerstone of web development. You'll learn to create well-structured web pages, understand HTML5 elements, and apply best practices for web development. By the end of the course, you'll be able to build accessible, responsive, and semantically correct web pages.",
        startDate: "August 15",
        learners: 12345,
        averageRating: 5.5,
        reviewsCount: "5k",
        name: "html"
      },
      {
        imageSrc : "https://cdn.builder.io/api/v1/image/assets/TEMP/2fd32f4ac4b13c496e37b7a961c891720de8bd47ba57740f318a3de28bb64351?apiKey=a6dad463439244ae86e3212633b4369a&&apiKey=a6dad463439244ae86e3212633b4369a",
        image:
          "https://cdn.builder.io/api/v1/image/assets/TEMP/9c20afe8f03bf41781ded8405d2f6918ebadaeb65a5b0936c9064a44904047e7?apiKey=a6dad463439244ae86e3212633b4369a&&apiKey=a6dad463439244ae86e3212633b4369a",
        title: "Mastering CSS for Modern Web Design",
        description: "This course provides a thorough understanding of CSS, focusing on styling and designing modern web interfaces. You'll learn CSS fundamentals, advanced styling techniques, responsive design principles, and best practices for creating visually appealing and accessible websites.",
        startDate: "August 15",
        learners: 12345,
        averageRating: 5.5,
        reviewsCount: "5k",
        name: "css"
      }
    ],
    'others' : [
      {
        imageSrc : "https://cdn.builder.io/api/v1/image/assets/TEMP/2fd32f4ac4b13c496e37b7a961c891720de8bd47ba57740f318a3de28bb64351?apiKey=a6dad463439244ae86e3212633b4369a&&apiKey=a6dad463439244ae86e3212633b4369a",
        image:
          "https://cdn.builder.io/api/v1/image/assets/TEMP/c50619eaecb6ea80d38d5e33f0271d68ba1f06c77031b21b7d08664c64c3c455?apiKey=a6dad463439244ae86e3212633b4369a&&apiKey=a6dad463439244ae86e3212633b4369a",
        title: "Data Structures and Algorithms",
        description: "This course provides an in-depth understanding of data structures and algorithms, essential for problem-solving in computer science. It covers foundational concepts, advanced data structures, and algorithmic techniques with hands-on exercises and real-world applications.",
        startDate: "August 15",
        learners: 12345,
        averageRating: 5.5,
        reviewsCount: "5k",
        name: "dsa"
      },
      {
        imageSrc : "https://cdn.builder.io/api/v1/image/assets/TEMP/2fd32f4ac4b13c496e37b7a961c891720de8bd47ba57740f318a3de28bb64351?apiKey=a6dad463439244ae86e3212633b4369a&&apiKey=a6dad463439244ae86e3212633b4369a",
        image:
          "https://cdn.builder.io/api/v1/image/assets/TEMP/510622f50ff15446a7314b66bf2dd6ff555efd04a575154550b38d317f46f3f4?apiKey=a6dad463439244ae86e3212633b4369a&&apiKey=a6dad463439244ae86e3212633b4369a",
        title: "Advance System Design",
        description: "This course provides a deep dive into system design principles and practices, essential for building scalable and efficient systems. It covers core concepts, architectural patterns, and real-world applications with hands-on exercises to enhance problem-solving skills in system design.",
        startDate: "August 15",
        learners: 12345,
        averageRating: 5.5,
        reviewsCount: "5k",
        name: "asd"
      },
      {
        imageSrc : "https://cdn.builder.io/api/v1/image/assets/TEMP/2fd32f4ac4b13c496e37b7a961c891720de8bd47ba57740f318a3de28bb64351?apiKey=a6dad463439244ae86e3212633b4369a&&apiKey=a6dad463439244ae86e3212633b4369a",
        image:
          "https://cdn.builder.io/api/v1/image/assets/TEMP/9c20afe8f03bf41781ded8405d2f6918ebadaeb65a5b0936c9064a44904047e7?apiKey=a6dad463439244ae86e3212633b4369a&&apiKey=a6dad463439244ae86e3212633b4369a",
        title: "Best Job Interview Practices",
        description: "This course equips you with essential skills for excelling in job interviews, covering preparation, effective communication, and strategies for handling common interview questions, including behavioral and technical ones. Through practical exercises, you'll refine your interview techniques, build confidence, and be better prepared to succeed in any interview scenario.",
        startDate: "August 15",
        learners: 12345,
        averageRating: 5.5,
        reviewsCount: "5k",
        name: "aip"
      }
    ]
  };

  const courseTypeClickHandler = (type_key) =>{
    setType(type_key);
  }

  return(
    <CoursesListingContainer>
      <ContentWrapper>
        <Header />
        <CoursesOffered>Courses offered</CoursesOffered>
        <CourseTabs courseTypeClickHandler={courseTypeClickHandler} type={type}/>
        <Divider />
        {/* <SubNavigation /> */}
        {courses[type].map((course, index) => (
          <CourseCard key={index} {...course} type={type}/>
        ))}
        <CareerCounselling />
      </ContentWrapper>
      <Footer style={{paddingBottom:'35px'}}/>
    </CoursesListingContainer>
  );
};

const CoursesListingContainer = styled.main`
  background-color: rgba(249, 250, 251, 1);
  display: flex;
  flex-direction: column;
  overflow: hidden;
  padding-top: 35px;
`;

const ContentWrapper = styled.div`
  align-self: center;
  display: flex;
  width: 100%;
  max-width: 1215px;
  flex-direction: column;
  align-items: center;

  @media (max-width: 991px) {
    max-width: 100%;
  }
`;

const CoursesOffered = styled.h1`
  color: rgba(0, 0, 0, 1);
  text-align: center;
  margin: 87px 0 0 103px;
  font: 500 34px Encode Sans Semi Condensed, -apple-system, Roboto, Helvetica,
    sans-serif;

  @media (max-width: 991px) {
    margin: 40px 0 0 10px;
  }
`;

const Divider = styled.hr`
  background: var(--Gray-200, #e4e7ec);
  align-self: center;
  width: 984px;
  max-width: 100%;
  height: 1px;
  border: none;
`;

export default CoursesListing;
